import { Container } from "@mui/material";

import Header from "../components/Header";
import Body from "../components/Body";
import Footer from "../components/Footer";

export const HomePage = () => {
  return (
    <>
      <Container maxWidth="xl">
        <Header />
        <Body />
      </Container>
      <Footer />
    </>
  );
};
